import React, { Component } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Slider, InputNumber, Tooltip } from 'antd';
import { Line } from 'react-chartjs-2'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { request } from '../../../utils/api';
import moment from 'moment'

let dataSpirit = {
    labels: ['0', '1', '2', '3', '4', '5', '6'],
    datasets: [
        {
        label: 'Flow Digital Assets Spirit',
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(219, 86, 224, 1)',
        borderColor: 'rgba(219, 86, 224, 1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(219, 86, 224, 1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 8,
        pointHoverRadius: 8,
        pointHoverBackgroundColor: 'rgba(219, 86, 224, 1)',
        pointHoverBorderColor: 'rgba(219, 86, 224, 1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 8,
        data: [50000, 50450, 50904.05, 51362.18, 51824.43, 52290.84, 52761.45]
        }, {
            label: 'Poupança',
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(215, 209, 236, 1)',
            borderColor: 'rgba(215, 209, 236, 1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(215, 209, 236, 1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 8,
            pointHoverRadius: 8,
            pointHoverBackgroundColor: 'rgba(215, 209, 236, 1)',
            pointHoverBorderColor: 'rgba(215, 209, 236, 1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 8,
            data: [50000, 50065.25, 50130.58, 50196, 50261.50, 50327.09, 50392.76],
        }
    ]
}

let options = {
   responsive: true,
   legend: {
      position: 'bottom',
      labels: {
          usePointStyle: true,
          fontColor: '#fff',
          fontSize: 14,
          fontFamily: 'Arial',
          boxWidth: 10
      }
   },
   scales: {
      xAxes: [{
         ticks: {
            fontColor: "#fff",
         },
         gridLines: {
            display: false,
            color: "#F7D9F8"
          },
      }],
      yAxes: [{
         ticks: {
            fontColor: "#fff",
            callback: function(value, index, values){ return 'R$ ' + value},
         },
         gridLines: {
            // display: false,
            color: "#F7D9F8"
          },
      }]
   },
   tooltips: {
        enabled: true,
        mode: 'single',
        callbacks: {
            label: function(tooltipItems, data) { 
                return data.datasets[tooltipItems.datasetIndex].label + ': R$' + tooltipItems.yLabel;
            }
        }
    },
}

export default class Spirit extends Component {
    constructor(props) {
        super (props)
        this.state = {
            option: 1,
            chartSpirit: dataSpirit,
            inputSpiritValue: 20000,
            inputMesSpiritValue: 6,
            minSpirit: 6,
            maxSpirit: 16,
            minInputSpirit: 20000,
            periodo: 'all',
            rentSpirit: '',
        }
    }

    componentDidMount = async () => {        
        try {
            const response = await request('operacional/getRentChart', 'GET')
            if (response.code === 12) {
                this.setState({
                    rentSpirit: response.dataS
                }, () => {
                    this.calculateChart()
                })
            } 
        } catch(e) {
            // console.log(e)
            // message.error('Não foi possível registrar a operação')
        }
    }
    onChange = value => {
        this.setState({
            inputSpiritValue: value,
        }, () => {
            this.calculateChart()
        });
      };

    onChangeMes = value => {
        this.setState({
            inputMesSpiritValue: value,
        }, () => {
            this.calculateChart()
        });
        
    };


    calculateChart() {
        let tipo
        let qt
        let label
        let mes
        
        tipo = 6
        label = 'Flow Digital Assets Spirit'
        qt = this.state.inputSpiritValue
        qt = parseFloat(qt)
        mes = this.state.inputMesSpiritValue
        
        let rent
        let labels = ['Início']
        let newData
        
            var past_date = new Date('06/01/2020');
            var current_date = new Date();
                
            var difference = (current_date.getFullYear()*12 + current_date.getMonth()) - (past_date.getFullYear()*12 + past_date.getMonth());
            let rendAsa = [qt]
            let rendPoupanca = [qt]
            let qtp = qt
            let helpMes = 0
            // console.log(difference)
            for(let i = 0; i < difference; i++) {
                if(i === 0) {
                    labels.push("Jun/2020")
                  } else {
                    var dt_helper = moment('2020-06-01')
                    var dt_somada = moment(dt_helper).add(i, 'M')
                      
                    labels.push(dt_somada.format('MMM')+"/"+dt_somada.format('Y'))
                  }
                if(this.state.rentSpirit[i]/100 > 0) {
                    qt = qt + (qt*((this.state.rentSpirit[i]/100)/2))
                } else {
                    qt = qt + (qt*((this.state.rentSpirit[i]/100)))
                }
                
                qtp = qtp + (qtp*0.005)
                rendAsa.push(Number(qt.toFixed(2)))
                rendPoupanca.push(Number(qtp.toFixed(2)))
                
            }
            newData = {
                labels: labels,
                    datasets: [
                        {
                        label: 'Flow Digital Assets Spirit',
                        fill: false,
                        lineTension: 0.1,
                        backgroundColor: 'rgba(219, 86, 224, 1)',
                        borderColor: 'rgba(219, 86, 224, 1)',
                        borderCapStyle: 'butt',
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: 'miter',
                        pointBorderColor: 'rgba(219, 86, 224, 1)',
                        pointBackgroundColor: '#fff',
                        pointBorderWidth: 8,
                        pointHoverRadius: 8,
                        pointHoverBackgroundColor: 'rgba(219, 86, 224, 1)',
                        pointHoverBorderColor: 'rgba(219, 86, 224, 1)',
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 8,
                        data: rendAsa
                        }, {
                            label: 'Poupança',
                            fill: false,
                            lineTension: 0.1,
                            backgroundColor: 'rgba(215, 209, 236, 1)',
                            borderColor: 'rgba(215, 209, 236, 1)',
                            borderCapStyle: 'butt',
                            borderDash: [],
                            borderDashOffset: 0.0,
                            borderJoinStyle: 'miter',
                            pointBorderColor: 'rgba(215, 209, 236, 1)',
                            pointBackgroundColor: '#fff',
                            pointBorderWidth: 8,
                            pointHoverRadius: 8,
                            pointHoverBackgroundColor: 'rgba(215, 209, 236, 1)',
                            pointHoverBorderColor: 'rgba(215, 209, 236, 1)',
                            pointHoverBorderWidth: 2,
                            pointRadius: 1,
                            pointHitRadius: 8,
                            data: rendPoupanca
                        }
                    ]
                
                }
        
        this.setState({
            chartSpirit: newData
        })
        

    }

    render() {
        return (
            <>
                
                <Container>
                    <Row>
                        <Col md={4} className="mt-5">
                            <label className="mt-5 text-white">Período<Tooltip title="O período total considera todo o período de atividade do Fundo"><FontAwesomeIcon className="ml-2" icon={faInfoCircle}></FontAwesomeIcon></Tooltip></label><br />
                            <label className="text-white sliderLabel mt-2">Jun/2020 - Hoje</label><br />
                            <label className="text-white">Valor<Tooltip title="Clique no número para digitar um valor ou use o slider abaixo"><FontAwesomeIcon className="mt-2 ml-2" icon={faInfoCircle}></FontAwesomeIcon></Tooltip></label>
                            <div>
                                <label className="sliderLabel mt-2 text-white">R$</label>
                                <InputNumber
                                    min={this.state.minInputSpirit}
                                    max={1000000}
                                    value={this.state.inputSpiritValue}
                                    onChange={this.onChange}
                                    className="tx-pink inputQuantia"
                                />
                            </div>
                            <div className="icon-wrapper d-flex align-items-center">
                                <small className="text-white pr-2">Min</small>
                                <Slider
                                    min={this.state.minInputSpirit}
                                    max={1000000}
                                    onChange={this.onChange}
                                    value={typeof this.state.inputSpiritValue === 'number' ? this.state.inputSpiritValue : 50000}
                                />
                                <small className="text-white pl-2">Max</small>
                            </div>
                            <br /><br />
                        </Col>
                        <Col md={8} className="mt-5 d-flex flex-column justify-content-center align-items-end">
                            <Line data={this.state.chartSpirit} options={options}/>
                            <small className="lineTerm tx-light-grey mt-5">*Rentabilidade da poupança calculada considerando SELIC em 13.25% a.a.<br /><br />- Rentabilidade passada não representa garantia de rentabilidade futura.<br />- A rentabilidade divulgada não é líquida de impostos.<br />- Fundos de investimento não contam com garantia do administrador, do gestor, de qualquer mecanismo de seguro ou Fundo Garantidor de Crédito - FGC.</small>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
}